import { render, staticRenderFns } from "./PromotionCouponReview.vue?vue&type=template&id=b297ae4c&"
import script from "./PromotionCouponReview.vue?vue&type=script&lang=js&"
export * from "./PromotionCouponReview.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCouponReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromotionCouponReview.vue"
export default component.exports